var _path, _path2, _path3, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgW(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 39,
    viewBox: "0 0 57 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.0001 0.973083H45.5898L39.5382 22.1239L33.3473 0.973083H23.6768L28.4742 17.1614L34.1794 38.678H44.686L57.0001 0.973083Z",
    fill: "#6A097D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5382 22.1198L33.3354 0.968933H23.6768L28.4742 17.1781L34.1794 38.6905H44.686L39.5382 22.1198Z",
    fill: "#6A097D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1L12.2464 38.7049H22.7491L28.5259 17.1925L33.395 1H23.7245L17.4619 22.1508L11.4104 1H0Z",
    fill: "#6A097D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2672 29.0583L16.885 28.9378L8.21777 26.3028L12.2468 38.7048H22.7495L24.7282 31.3359L17.2672 29.0583Z",
    fill: "url(#paint0_linear_5879_518)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8105 33.4994L34.1801 38.678H44.6867L45.1446 37.2815L32.8105 33.4994Z",
    fill: "url(#paint1_linear_5879_518)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5879_518",
    x1: 8.21335,
    y1: 33.7195,
    x2: 24.0352,
    y2: 32.2039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5879_518",
    x1: 32.3626,
    y1: 37.2798,
    x2: 44.1782,
    y2: 36.1479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgW);
export default __webpack_public_path__ + "static/media/W.36bdfbaef8fcdd9880d0622ca1ba71d2.svg";
export { ForwardRef as ReactComponent };